if(location.href.match("/account/login") || (window.location.pathname== '/')){
  jQuery(document).ready(function () {

	var appUrl = "https://store.xecurify.com";
	var flagfield;
	var otpvalue;

	$('head').append('<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.min.css">');
	$('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.js"></script>');
	$('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.min.js"></script>');
	$('head').append('link href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js">');
	$('head').append('<meta name="viewport" content="width=device-width, initial-scale=1" />');
	$('head').append("<form id='verifyotp' action='" + appUrl + "/moas/rest/shopify/api/auth/verifyOtp2fa' method='GET'> " +
		"<input type='text' id='txid' name='txid'></input>" +
		"<input type='text' id='mobilenumber' name='mobilenumber'></input>" +
		"<input type='text' id='otp' name='otp'></input>" +
		"<input type='text' id='shop' name='shop'></input>" +
		"<input type='text' id='authtype' name='authtype'></input>" +
		"<input type='text' id='shopcheckouturl' name='shopcheckouturl'></input>" +
		"</form>");


	 $('#CustomerLogin').hide();
	 $('#login').hide();

if(window.location.pathname == '/') {
    // $('#shopify-section-template--17027371860263__7896f85a-317b-49d5-b060-ef71ee0732cb').append(document.getElementById("shopify-section-template--17027371860263__7896f85a-317b-49d5-b060-ef71ee0732cb").style.display="none");
  	$('#shopify-section-template--17027371860263__7896f85a-317b-49d5-b060-ef71ee0732cb').append(
		'<div id="MOLoginModal" class="modal" style="font-weight: 700;font-family: Harmonia Sans;display: none; /* Hidden by default */ position:relative; /* Stay in place */ z-index:0;/* Sit on top */ padding-top:0%;/* Location of the box */ left: 0;	top:10;/* Full width */ /* Full height */	overflow: hidden; /* Enable scroll if needed */ /* Fallback color */ /* Black w/ opacity */	opacity:1; margin-bottom :50px; padding:1rem; " onload="OTPInput();">' +

		'<div class="mo-modal-content" style="">' +
		'<p id="MOheading" style="display:inline-block;">Login With OTP</p>' +
		'<p style="" id="mobileNumberText">Enter your contact number to login.</p><br>' +
		'<p style="display:none;" id="otpText">Enter OTP sent to your number.</p>' +
        '<div style = "margin:auto;">'+
         '<button id="whatsappButton"  style="display:inline-block;">Whatsapp</button>' +
		 '<button id="phoneButton"  style="display:inline-block;pointer-events: none; background-color:#004B49; border:none;color:#fff">Phone</button><br>' +
		 '</div>'+
		'<div id="mobileField"><input type="text" id="mobileNumber" style="display:inline-block;" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57));"></div>' +
		'<div id="input-code" style="margin-top: 30px;padding: 0px;display: flex; margin: auto; justify-content: space-evenly; ">' +
		'<input type="text" id="otpinput1" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput2" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput3" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput4" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput5" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput6" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'</div>' +
		'<label id="mobileError" style="display:inline-block;"></label>' +
		'<button id="verifyButton" style="display:none; -webkit-appearance: button; cursor: pointer;">VERIFY</button><br>' +
		'<span id="timer" style="color:#318cd0"></span>' +
		'<div style="margin-top: 18px;"><a href="#" id="resendButton" style="display:none;">Resend OTP</a></div>' +
		'<div style="margin-top: 18px;"><a href="#" id="emailResendButton" style="display:none;">Resend OTP</a></div>' +
        '<div style="margin-top: 18px;"><a href="#" id="whatsappResendButton" style="display:none;">Resend OTP</a></div>' +
		'<div style="margin-top: 18px;"><a href="#" id="changeButton" style="display:none;">Change Phone Number</a></div>' +
		'<button id="submitButton"  style="display:inline-block;">NEXT</button>' +
        '<button id="whatsappSubmitButton" style="display:none;">NEXT</button>' +
		'<button class="btn default" id="defaultShopifylogin" style="border:none ;cursor: pointer; background-color:inherit; text-decoration: underline; font-size:18px">Login With Shopify</button>' +
		'</div>' +
		'</div>');

$('#shopify-section-template--17027371860263__7896f85a-317b-49d5-b060-ef71ee0732cb').append(
		'<div id="updateModal" class="modal" style="display: none; display: none; /* Hidden by default */ position: absolute; /* Stay in place */ z-index: 999; /* Sit on top */ padding-top: 5%; /* Location of the box */ left: 0;	top: 0;	width: 100%;  /* Full width */ height: 100%; /* Full height */	overflow: auto; /* Enable scroll if needed */ background-color: rgb(0,0,0); /* Fallback color */ background-color: rgba(0,0,0,0.4); /* Black w/ opacity */	opacity:1;">' +

		'<div class="mo-modal-content" style="background:white;padding:20px;">' +

		'<p><span id = "MOclosebuttonprofile" class="close" style="float: right;font-size: 21px;font-weight: 700;line-height: 1;color: #000;text-shadow: 0 1px 0 #fff;filter: alpha(opacity=20);opacity: .2; cursor: pointer">x</span></p>' +
		'<p id="MOupdateheading" style="color:#0d0d0d; text-align: center; font-weight: 600; font-size: 22px; display:inline-block; font-family:sans-serif ; border-bottom: 3px solid #d47303;" >UPDATE PROFILE</p><br><br>' +
		'<hr style="margin: 4rem 0;">' +
		'<p style="text-align: center; color: #131212; width : 100% ;font-weight: 600; font-family:sans-serif; font-size: 18px;" id="MobileNumber">Enter Mobile Number</p>' +
		'<input type="text" style="display:inline-block; background-color: #f5f4f4; color:#0d0d0d; padding:18px 36px; text-align: center; font-size:14px; margin:5px; width:100%; border: 2px solid #f6f6f6;"  id="updateMobileNumber" >' +
		'<label id="mobileError" style="color: #131212;font-size: 14px; letter-spacing:1px; width : 80% "></label><br>' +
		'<hr style="margin: 4rem 0;">' +

		'<button id="updatenumbersubmit" class="btn" style="cursor: pointer; border: 1px solid transparent; background-color:#f16c13; text-align=center; box-shadow: 0 10px 30px 0 rgba(233, 189, 95, 0.4); border-radius: 5px 5px 5px 5px; color:white; font-size:17px; padding:13px 60px;">UPDATE</button><br>' +
		'</div>' +

		'</div>');
}
   if( location.href.match("/account/login")){
        console.log("login");

	$('#MainContent').append(
		'<div id="MOLoginModal" class="modal" style="font-weight: 700;font-family: Harmonia Sans;display: none; /* Hidden by default */ position:relative; /* Stay in place */ z-index:0;/* Sit on top */ padding-top:0%;/* Location of the box */ left: 0;	top:10;/* Full width */ /* Full height */	overflow: hidden; /* Enable scroll if needed */ /* Fallback color */ /* Black w/ opacity */	opacity:1; margin-bottom :50px; padding:1rem; " onload="OTPInput();">' +

		'<div class="mo-modal-content" style="">' +
		'<p id="MOheading" style="display:inline-block;">Login With OTP</p>' +
		'<p style="" id="mobileNumberText">Enter your contact number to login.</p><br>' +
		'<p style="display:none;" id="otpText">Enter OTP sent to your number.</p>' +
      		'<div style = "margin:auto;">'+
         '<button id="whatsappButton"  style="display:none;">Whatsapp 111</button>' +
		 '<button id="phoneButton"  style="display:none;pointer-events: none; background-color:#004B49; border:none;color:#fff">Phone111</button><br>' +
		'</div>'+
		'<div id="mobileField"><input type="text" id="mobileNumber" maxlength="10" style="display:inline-block;" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57));"></div>' +
		'<div id="input-code" style="margin-top: 30px;padding: 0px;display: flex; margin: auto; justify-content: space-evenly; ">' +
		'<input type="text" id="otpinput1" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput2" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput3" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput4" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput5" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'<input type="text" id="otpinput6" class="passInput" style="display:none;" maxlength="1" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
		'</div>' +
		'<label id="mobileError" style="display:inline-block;"></label>' +
		'<button id="verifyButton" style="display:none; -webkit-appearance: button; cursor: pointer;">VERIFY</button><br>' +
		'<span id="timer" style="color:#318cd0"></span>' +
		'<div style="margin-top: 18px;"><a href="#" id="resendButton" style="display:none;">Resend OTP</a></div>' +
		'<div style="margin-top: 18px;"><a href="#" id="emailResendButton" style="display:none;">Resend OTP</a></div>' +
        '<div style="margin-top: 18px;"><a href="#" id="whatsappResendButton" style="display:none;">Resend OTP</a></div>' +
		'<div style="margin-top: 18px;"><a href="#" id="changeButton" style="display:none;">Change Phone Number</a></div>' +
		'<button id="submitButton" style="display:inline-block;">NEXT</button>' +
        '<button id="whatsappSubmitButton" style="display:none;">NEXT</button>' +
		'<button class="btn default" id="defaultShopifylogin" style="border:none ;cursor: pointer; background-color:inherit; text-decoration: underline; font-size:18px">Login With Shopify</button>' +
		'</div>' +
		'</div>');


	$('#MainContent').append(
		'<div id="updateModal" class="modal" style="display: none; display: none; /* Hidden by default */ position: absolute; /* Stay in place */ z-index: 999; /* Sit on top */ padding-top: 5%; /* Location of the box */ left: 0;	top: 0;	width: 100%;  /* Full width */ height: 100%; /* Full height */	overflow: auto; /* Enable scroll if needed */ background-color: rgb(0,0,0); /* Fallback color */ background-color: rgba(0,0,0,0.4); /* Black w/ opacity */	opacity:1;">' +

		'<div class="mo-modal-content" style="background:white;padding:20px;">' +

		'<p><span id = "MOclosebuttonprofile" class="close" style="float: right;font-size: 21px;font-weight: 700;line-height: 1;color: #000;text-shadow: 0 1px 0 #fff;filter: alpha(opacity=20);opacity: .2; cursor: pointer">x</span></p>' +
		'<p id="MOupdateheading" style="color:#0d0d0d; text-align: center; font-weight: 600; font-size: 22px; display:inline-block; font-family:sans-serif ; border-bottom: 3px solid #d47303;" >UPDATE PROFILE</p><br><br>' +
		'<hr style="margin: 4rem 0;">' +
		'<p style="text-align: center; color: #131212; width : 100% ;font-weight: 600; font-family:sans-serif; font-size: 18px;" id="MobileNumber">Enter Mobile Number</p>' +
		'<input type="text" style="display:inline-block; background-color: #f5f4f4; color:#0d0d0d; padding:18px 36px; text-align: center; font-size:14px; margin:5px; width:100%; border: 2px solid #f6f6f6;"  id="updateMobileNumber" >' +
		'<label id="mobileError" style="color: #131212;font-size: 14px; letter-spacing:1px; width : 80% "></label><br>' +
		'<hr style="margin: 4rem 0;">' +

		'<button id="updatenumbersubmit" class="btn" style="cursor: pointer; border: 1px solid transparent; background-color:#f16c13; text-align=center; box-shadow: 0 10px 30px 0 rgba(233, 189, 95, 0.4); border-radius: 5px 5px 5px 5px; color:white; font-size:17px; padding:13px 60px;">UPDATE</button><br>' +
		'</div>' +

		'</div>');

    }
	var Hash_String = window.location.search;
	var CheckoutUrl = '';
	const Hash_Param = new URLSearchParams(Hash_String);
	if (Hash_Param.has('hash')) {
		document.cookie = "storefront_digest=" + Hash_Param.get('hash') + "; path=/";
		var shop_name = window.location.hostname;
		window.location.href = "https://" + shop_name;
	}
	if (Hash_Param.has('checkout_url')) {
		CheckoutUrl = "checkout";

	}
	else {
		CheckoutUrl = "/account";
	}

	$("#mobileNumber").keyup(function (event) {
		if (event.keyCode === 13) {
			$("#submitButton").click();
		}
	});

	$("#otpinput6").keyup(function (event) {
		if (event.keyCode === 13) {
			$("#verifyButton").click();
		}
	});
	if ($('#CustomerLogin').css('display') == 'none')
		$("#MOLoginModal").css("display", "block");
	else
		$("#MOLoginModal").css("display", "none");

	$.getScript("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js", function () {
		flagnum = document.querySelector("#mobileNumber");
		flagfield = window.intlTelInput(flagnum, ({
			separateDialCode: true,
			hiddenInput: "full_phone",
			initialCountry: "IN",
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
		}));
	});

	const $inp = $(".passInput");
	$inp.on({
		paste(ev) { // Handle Pasting
			const clip = ev.originalEvent.clipboardData.getData('text').trim();
			// Allow numbers only
			if (!/\d{6}/.test(clip)) return ev.preventDefault(); // Invalid. Exit here. Split string to Array or characters
			const s = [...clip];
			// Populate inputs. Focus last input.
			$inp.val(i => s[i]).eq(5).focus();
		},
		input(ev) { // Handle typing
			const i = $inp.index(this);
			if (this.value) $inp.eq(i + 1).focus();
		},
		keydown(ev) { // Handle Deleting 
			const i = $inp.index(this);
			if (!this.value && ev.key === "Backspace" && i) $inp.eq(i - 1).focus();
		}
	});


	var cartCookieValue = getCookie("cart");
	if (typeof cartCookieValue !== 'undefined') {
		createCookie("cart", cartCookieValue, 15);
	}


	var styles = '.mo-modal-content {' +
		'margin: auto; padding:5px; border: 1px solid #888; width: 34%; text-align:center;border: none; }' +
		'html {-ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%}' +
		'body {line-height: 1.1; color: #333; background-color: #fff;}' +
		'.iti {width : 80%;}' +
		'.iti__selected-dial-code {font-size: 14px ;     background-color: transparent }'+
		'div[class^="iti__flag"] { display: inline-block ;}' +
		'.passInput{text-align: center;line-height: 8px;padding: 0 !important;font-size: 20px;height: 40px;width: 40px;border-radius: 10px; border: 1px solid black; margin-bottom: 5px;}' +
		'#MOheading{color:#0d0d0d; text-align: center; font-weight: 600; font-size: 40px; width :60% ;margin : 0 0 15px}' +
		'#mobileNumberText{text-align: center; color: #131212; font-size: 18px; letter-spacing:1px width:60%}' +
		'#mobileNumber{width: 100% ;margin-top: 5px;font-weight:550; margin-bottom: 20px; padding-left:25% !important; font-size:16px;border: 1px solid #a5a5a5; height:4rem;}' +
		'#mobileError{color: #131212;font-size: 14px; letter-spacing:1px ; width : 80% ;}' +
		'#submitButton{cursor: pointer; width: 80% ; color: #fff; background-color: #004B49;  margin-top: 5px;border-radius:10px; margin-bottom: 20px; text-align: center; font-size:18px;border: 2px solid #004B49; height:4rem;}' +
		'#whatsappButton{ display:none; cursor: pointer; width: 38%; padding : 0px 40px;  color:#004B49; border-radius:10px;  background-color: transparent; margin-top: 2px; margin-bottom: 20px; text-align: center; font-size:18px;border: 2px solid #004B49; height:4rem;}' +
		'#phoneButton{cursor: pointer; width: 38%; padding: 0px 40px;  color:#004B49; border-radius:10px;  background-color: transparent;margin-top: 2px; margin-bottom: 20px; margin-left: 5%; text-align: center; font-size:18px;border: 2px solid #004B49; height:4rem;}' +
        '#whatsappSubmitButton{cursor: pointer;color:#fff; width: 80% ;border-radius:10px; background-color: #004B49;  margin-top: 5px; margin-bottom: 20px; text-align: center; font-size:18px;border: 2px solid #004B49; height:4rem;}' +
        '#verifyButton{cursor: pointer; color:#fff; width: 80%;  background-color: #004B49; margin-top: 20px; margin-bottom: 20px; text-align: center; font-size:18px;border: 2px solid #004B49; height:4rem;}' +
		'#resendButton{color:black;font-size: 18px; letter-spacing:1px;}' +
        '#whatsappResendButton{color:black;font-size: 18px; letter-spacing:1px;}' +
        '#whatsappButton:hover {background-color: #004B49; color: #fff}'+
		'#phoneButton:hover{background-color:#004B49;color: #fff}'+
		'#changeButton{color:black; position: relative; top: -10px;font-size: 18px; letter-spacing:1px; }' +
		'#otpText{ color:#131212; font-weight:600; font-family:sans-serif; font-size:18px}' +
		'#MOLoginModal{' +
		' padding-top: 8%; opacity:1}' +
		// '@media (max-width : 50%){ #MOLoginModal .mo-modal-content {' +
		// 'box-shadow: 2px 2px 6px 2px; margin: auto; padding: 20px; margin-bottom:50px;border: 1px solid #888; width: 92%; text-align:center;' +
		// '}'+
		// '}'+
		'@media (max-width : 800px){ .mo-modal-content {' +
		'width:100%; font-size:25px;' +
		'}' +
		'}' +
      '@media (max-width : 800px){ #whatsappButton {' +
		'width:92%;' +
		'}' +
		'}' +
      '@media (max-width : 800px){ #phoneButton {' +
		'width:92%;margin-left:0%' +
		'}' +
		'}' +
      '@media (max-width : 800px){ #mobileNumber {' +
		'padding-left:30%!important' +
		'}' +
		'}' +
      '@media (max-width : 800px){ #mobileField {' +
		'width:116%; margin-left:-9%;' +
		'}' +
		'}' +
		'#updateModal{' +
		' padding-top: 8%; opacity:1}' +
		'@media (max-width : 420px){ #updateModal .mo-modal-content {' +
		'background-color: rgba(0,0,0,0.4) box-shadow: 2px 2px 6px 2px; margin: auto; padding: 20px; border: 1px solid #888; width: 92%; text-align:center;' +
		'}' +

		'.close {color: #aaaaaa; float: right; position: relative; top: -16px; font-size: 28px; font-weight: bold;}' +

		'.close:hover,' +
		'.close:focus { color: #000; text-decoration: none; cursor: pointer; }' +
		'.modal { display: none; /* Hidden by default */ position: relative; /* Stay in place */ z-index: 999; /* Sit on top */ padding-top: 5%; /* Location of the box */ left: 0;	top: 0;	width: 100%; /* Full width */ height: 100%; /* Full height */	overflow: auto; /* Enable scroll if needed */  /* Fallback color */  /* Black w/ opacity */	opacity:1; }';


	var styleSheet = document.createElement("style");
	styleSheet.type = "text/css";
	styleSheet.innerText = styles;
	document.head.appendChild(styleSheet);

var shopifyLogin = "off";
if( shopifyLogin == "off" ){
  $('#defaultShopifylogin').hide();
}
var smsStatus = "off";
var emailStatus = "off";
var whatsappStatus = "off";

if (smsStatus == "on" && emailStatus == "off" && whatsappStatus == "off")
{
    $('#phoneButton').hide();
    $('#whatsappButton').hide();
    $('#mobileNumber').show();
    $('#submitButton').show();
    $('#whatsappSubmitButton').hide();
    $('#mobileField').show();
    $('#mobileNumberText').text('Enter your mobile number to login');
}

if (smsStatus == "off" && emailStatus == "off" && whatsappStatus == "on")
{
    $('#phoneButton').hide();
    $('#whatsappButton').hide();
    $('#mobileNumber').show();
    $('#submitButton').hide();
    $('#whatsappSubmitButton').hide();
    $('#mobileField').show();
    $('#mobileNumberText').text('Enter your Whatsapp number to login');
}
	document.getElementById('MOclosebuttonprofile').onclick = function () {
		document.getElementById('updateModal').style.display = 'none';
	}


	var current_url = window.location + " ";
	if (current_url.indexOf("account") > 0 && current_url.indexOf("account/login") < 0 && current_url.indexOf("account/register") < 0) {
		//var els1 = document.getElementById("customer_logout_link");
		var anchors = document.querySelectorAll('a[href*="/account/addresses"]');
		var els1 = anchors[0];
		var el = document.createElement("div");
		el.innerHTML = '<a href="#" id="profile_update">Update Profile</a><br><br>';

		els1.parentNode.insertBefore(el, els1);
		$.ajax(
			{
				url: appUrl + "/moas/rest/shopify/getuserinfo2fa?shop=" + window.location.hostname + "&id=" + ShopifyAnalytics.meta.page.customerId,
				type: "GET",
				headers:{ 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {
					if (result.status == 'success') {
						document.getElementById("userEmail").value = result.email;
						if (result.phone) {
							document.getElementById("updateMobileNumber").value = result.phone;

						}

					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
				}
			});
	}



	if (document.getElementById("profile_update")) {
		document.getElementById("profile_update").addEventListener('click', function () {

			document.getElementById('updateModal').style.display = 'block';
		});
	}
	document.getElementById("updatenumbersubmit").addEventListener('click', function () {

		mobileErrorHandler.innerHTML = "";
		let emailid = "+" + document.getElementById("updateMobileNumber").value + "@" + window.location.hostname;
		$.ajax(
			{
				url: appUrl + "/moas/rest/shopify/updateuserinfo2fa?shop=" + window.location.hostname + "&id=" + ShopifyAnalytics.meta.page.customerId + "&number=" + document.getElementById("updateMobileNumber").value + "&email=" + emailid,
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {

					if (result.status == 'true') {
						alert("Your profile has been updated!")
						document.getElementById("mobileError").innerHTML = "";
						document.getElementById('updateModal').style.display = 'none';

					}
					else if (result.status == 'false') {
						window.alert("Phone number has already been taken")
					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
				}
			}
		);

	});

	var submitButtonHandle = document.getElementById('submitButton');
	let mobileNumberHandle = document.getElementById('mobileNumber')
	let mobileNumberTextHandle = document.getElementById('mobileNumberText')
	let otpTextHandle = document.getElementById('otpText');
	let otp1Handle = document.getElementById('otpinput1');
	let otp2Handle = document.getElementById('otpinput2');
	let otp3Handle = document.getElementById('otpinput3');
	let otp4Handle = document.getElementById('otpinput4');
	let otp5Handle = document.getElementById('otpinput5');
	let otp6Handle = document.getElementById('otpinput6');
	let mobileErrorHandler = document.getElementById("mobileError");
	let verifyButtonHandle = document.getElementById('verifyButton');
	let defaultloginHandle = document.getElementById("defaultShopifylogin");
    let defaultHomeHandle = document.getElementById("shopify-section-template--17027371860263__7896f85a-317b-49d5-b060-ef71ee0732cb");
	var txId;
	let resendButtonHandle = document.getElementById('resendButton');
	let changeButtonHandle = document.getElementById('changeButton');
    let whatsappResendButtonHandle = document.getElementById('whatsappResendButton');
	var phoneNumber;
	var contact;
	var flag = document.createElement('style');
	var phoneButtonHandle = document.getElementById('phoneButton');
    var whatsappButtonHandler = document.getElementById('whatsappButton')
    var whatsappSubmitButtonHandle = document.getElementById('whatsappSubmitButton')

    whatsappButtonHandler.addEventListener('click', function () {
		mobileNumberHandle.style = 'display:';
		submitButtonHandle.style = 'display:none';
		changeButtonHandle.innerHTML = 'Change Whatsapp Phone Number';
		mobileNumberTextHandle.innerHTML ='Enter your whatsapp number to login.';
		phoneButtonHandle.style = 'pointer-events : pointer;';
        whatsappButtonHandler.style = 'pointer-events :none; background-color:#004B49 ;border:none; color:#fff';
        whatsappSubmitButton.style = 'display:inline-block';
        $('.iti').show();
	});


	phoneButtonHandle.addEventListener('click', function () {
		mobileNumberHandle.style = 'display:inline-block';
		submitButtonHandle.style = 'display:inline-block';
		changeButtonHandle.innerHTML = 'Change Phone Number';
		mobileNumberTextHandle.innerHTML ='Enter your contact number to login.';
		phoneButtonHandle.style = 'pointer-events :none; background-color:#004B49 ;border:none; color:#fff';
        whatsappButtonHandler.style = 'pointer-events :pointer';
        whatsappSubmitButton.style = 'display:none';
        $('.iti').show();
	});


	submitButtonHandle.addEventListener('click', function () {
		phoneNumber = flagfield.getNumber();
		contact = phoneNumber.substring(1);
		if (flagfield.isValidNumber()) {
			mobileErrorHandler.innerHTML = "Please wait. We are sending OTP on your Mobile Number";
			$.ajax(
				{
					url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + contact + "&action=register",
					type: "GET",
					headers:{ 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
					success: function (result) {

						if (result.status == 'SUCCESS') {

							mobileErrorHandler.innerHTML = "";

							mobileNumberHandle.style = 'display:none'

							mobileNumberTextHandle.style = 'display:none'

							submitButtonHandle.style = 'display:none'

							phoneButtonHandle.style = 'display:none'

                            whatsappButtonHandler.style = 'display:none'

							// emailButtonHandle.style = 'display:none'

							otpTextHandle.style = 'display:inline-block;'

							otp1Handle.style = 'display:inline-block;'

							otp2Handle.style = 'display:inline-block;'

							otp3Handle.style = 'display:inline-block;'

							otp4Handle.style = 'display:inline-block;'

							otp5Handle.style = 'display:inline-block;'

							otp6Handle.style = 'display:inline-block;'
                            var otpDigitsNumber = "6";
                            if( otpDigitsNumber == "4"){
                              $('#otpinput5').hide();
                              $('#otpinput6').hide();
                            }

							verifyButtonHandle.style = 'display:inline-block;'

							resendButtonHandle.style = 'display:inline-block;';

							changeButtonHandle.style = 'display:inline-block;';

							flag.innerHTML = '.iti__selected-flag[class^="iti__"] { display: none; }';

							document.head.appendChild(flag);

							txId = result.txId;

						}
						else if (result.status == 'false') {
							mobileErrorHandler.innerHTML = "Mobile Number entered is invalid. Please check or add mobile number to your profile";
						}
						else if (result.status == 'FAILED' ) {

							mobileErrorHandler.innerHTML = "Transaction limit for this number is exceeded. Please change the number";
						}

					},

					error: function (xhr, status, p3) {
						var err = "Error " + " " + status + " " + p3;
						if (xhr.responseText && xhr.responseText[0] == "{") {
							err = JSON.parse(xhr.responseText).message;
							console.log(err);
						}
						alert(err);
					}

				});
		}
		else {
			alert('Invalid phone number.');
		}
	});

//whatsapp
whatsappSubmitButtonHandle.addEventListener('click', function () {
    phoneNumber = flagfield.getNumber();
    contact = phoneNumber.substring(1);
    if (flagfield.isValidNumber()) {
        mobileErrorHandler.innerHTML = "Please wait. We are sending OTP on your Whatsapp Number";
        $.ajax(
            {
                url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + contact + "&delivery=whatsapp&action=register",
                type: "GET",
                headers:{ 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
                success: function (result) {

                    if (result.status == 'SUCCESS') {

                        mobileErrorHandler.innerHTML = "";

                        mobileNumberHandle.style = 'display:none'

                        mobileNumberTextHandle.style = 'display:none'

                        submitButtonHandle.style = 'display:none'

                        whatsappSubmitButtonHandle.style = 'display:none'

                        phoneButtonHandle.style = 'display:none'

                        whatsappButtonHandler.style = 'display:none'

                        // emailButtonHandle.style = 'display:none'

                        otpTextHandle.style = 'display:block;'

                        otp1Handle.style = 'display:inline-block;'

                        otp2Handle.style = 'display:inline-block;'

                        otp3Handle.style = 'display:inline-block;'

                        otp4Handle.style = 'display:inline-block;'

                        otp5Handle.style = 'display:inline-block;'

                        otp6Handle.style = 'display:inline-block;'
var otpDigitsNumber = "6";
if( otpDigitsNumber == "4"){
$('#otpinput5').hide();
$('#otpinput6').hide();
}

                        verifyButtonHandle.style = 'display:inline-block;'

                        resendButtonHandle.style = 'display:inline-block;';

                        changeButtonHandle.style = 'display:inline-block;';

                        flag.innerHTML = '.iti__selected-flag[class^="iti__"] { display: none; }';

                        document.head.appendChild(flag);

                        txId = result.txId;

                    }
                    else if (result.status == 'false') {
                        mobileErrorHandler.innerHTML = "Mobile Number entered is invalid. Please check or add mobile number to your profile";
                    }
                    else if (result.status == 'FAILED' ) {

                        mobileErrorHandler.innerHTML = "Transaction limit for this number is exceeded. Please change the number";
                    }

                },

                error: function (xhr, status, p3) {
                    var err = "Error " + " " + status + " " + p3;
                    if (xhr.responseText && xhr.responseText[0] == "{") {
                        err = JSON.parse(xhr.responseText).message;
                        console.log(err);
                    }
                    alert(err);
                }

            });
    }
    else {
        alert('Invalid Whatsapp number.');
    }
});

//whatsapp resend
whatsappResendButtonHandle.addEventListener('click', function () {
    phoneNumber = flagfield.getNumber();
    contact = phoneNumber.substring(1);
      const url = new URL(window.location.href);
      if(phoneNumber = "" && url.has('mobilenumber'));
      {	
        contact = url.searchParams.get('mobilenumber').replace(/#/g, '');
      }
    mobileErrorHandler.innerHTML = "Please Wait. We are sending OTP again.";
   $.ajax(
        {
            url:  appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + contact + "&delivery=whatsapp&action=register" ,
            type: "GET",
            headers:{ 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
            success: function (result) {


                if (result.status == 'SUCCESS') {

                    mobileErrorHandler.innerHTML = "";


                    mobileNumberHandle.style = 'display:none'

                    mobileNumberTextHandle.style = 'display:none'

                    submitButtonHandle.style = 'display:none'
                    phoneButtonHandle.style = 'display:none'
                    whatsappButtonHandler.style = 'display:none'
                    // emailButtonHandle.style = 'display:none'

                    otpTextHandle.style = 'display:block;'

                    otp1Handle.style = 'display:inline-block;'

                    otp2Handle.style = 'display:inline-block;'

                    otp3Handle.style = 'display:inline-block;'

                    otp4Handle.style = 'display:inline-block;'

                    otp5Handle.style = 'display:inline-block;'

                    otp6Handle.style = 'display:inline-block;'
var otpDigitsNumber = "6";
if( otpDigitsNumber == "4"){
$('#otpinput5').hide();
$('#otpinput6').hide();
}
                    verifyButtonHandle.style = 'display:inline-block;'

                    whatsappResendButtonHandle.style = 'display:inline-block;';

                    changeButtonHandle.style = 'display:inline-block;';

                    txId = result.txId;

                }
                else if (result.status == 'false') {
                    mobileErrorHandler.innerHTML = "The entered mobile phone number is invalid. Please check your mobile number or add your mobile number to your profile ";
                }
            },
            error: function (xhr, status, p3, p4) {
                //var err = "Error " + " " + status + " " + p3;
                //if(status== "FAILED")
                // if (xhr.responseText && xhr.responseText[0] == "{")
                // 	err = JSON.parse(xhr.responseText).message;
                //alert(err);
            }
        }
    );
});



	resendButtonHandle.addEventListener('click', function () {
		phoneNumber = flagfield.getNumber();
      contact = phoneNumber.substring(1);
      const url = new URL(window.location.href);
      if(phoneNumber = "" && url.has('mobilenumber'))
      {	
        contact = url.searchParams.get('mobilenumber').replace(/#/g, '');
      }
		mobileErrorHandler.innerHTML = "Please Wait. We are sending OTP again.";
       $.ajax(
			{
				url:  appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&number=" + contact + "&action=register",
				type: "GET",
				headers:{ 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {


					if (result.status == 'SUCCESS') {

						mobileErrorHandler.innerHTML = "";


						mobileNumberHandle.style = 'display:none'

						mobileNumberTextHandle.style = 'display:none'

						submitButtonHandle.style = 'display:none'
						phoneButtonHandle.style = 'display:none'
						

						otpTextHandle.style = 'display:block;'

						otp1Handle.style = 'display:inline-block;'

						otp2Handle.style = 'display:inline-block;'

						otp3Handle.style = 'display:inline-block;'

						otp4Handle.style = 'display:inline-block;'

						otp5Handle.style = 'display:inline-block;'

						otp6Handle.style = 'display:inline-block;'
var otpDigitsNumber = "6";
if( otpDigitsNumber == "4"){
  $('#otpinput5').hide();
  $('#otpinput6').hide();
}
						verifyButtonHandle.style = 'display:inline-block;'

						resendButtonHandle.style = 'display:inline-block;';

						changeButtonHandle.style = 'display:inline-block;';

						txId = result.txId;

					}
					else if (result.status == 'false') {
						mobileErrorHandler.innerHTML = "The entered mobile phone number is invalid. Please check your mobile number or add your mobile number to your profile ";
					}
				},
				error: function (xhr, status, p3, p4) {
					//var err = "Error " + " " + status + " " + p3;
					//if(status== "FAILED")
					// if (xhr.responseText && xhr.responseText[0] == "{")
					// 	err = JSON.parse(xhr.responseText).message;
					//alert(err);
				}
			}
		);
	});



	changeButtonHandle.addEventListener('click', function () {
		phoneNumber = flagfield.getNumber();
		contact = phoneNumber.substring(1);
          
		if(changeButtonHandle.innerHTML == 'Change Email Address')
		{
            mobileErrorHandler.innerHTML = "Please change your Email Address";
			submitButtonHandle.style = 'display:none';
			emailSubmitButtonHandle.style = 'display:inline-block';
			emailHandle.style = 'display:inline-block'
	     	phoneButtonHandle.style = 'display:none'
						
		emailButtonHandle.style = 'display:none'

		otpTextHandle.style = 'display:none'

		otp1Handle.style = 'display:none'

		otp2Handle.style = 'display:none'

		otp3Handle.style = 'display:none'

		otp4Handle.style = 'display:none'

		otp5Handle.style = 'display:none'

		otp6Handle.style = 'display:none'

		verifyButtonHandle.style = 'display:none'

		resendButtonHandle.style = 'display:none'
		// emailResendButtonHandle.style = 'display:none'

		changeButtonHandle.style = 'display:none'
		}
        else if(changeButtonHandle.innerHTML == 'Please change your Mobile Number'){
            mobileErrorHandler.innerHTML = "Please change your Mobile Number"


            mobileNumberTextHandle.style = 'display:inline-block;'
    
            mobileNumberHandle.style = 'display:block;'
    
            submitButtonHandle.style = 'display:inline-block;'
            whatsappSubmitButtonHandle.style = 'display:inline-block;'
            
            phoneButtonHandle.style = 'display:none'
                            
            // emailButtonHandle.style = 'display:none'
    
            otpTextHandle.style = 'display:none'
    
            otp1Handle.style = 'display:none'
    
            otp2Handle.style = 'display:none'
    
            otp3Handle.style = 'display:none'
    
            otp4Handle.style = 'display:none'
    
            otp5Handle.style = 'display:none'
    
            otp6Handle.style = 'display:none'
    
            verifyButtonHandle.style = 'display:none'
    
            resendButtonHandle.style = 'display:none'
    
            changeButtonHandle.style = 'display:none'
    
            flag.innerHTML = '.iti__selected-flag[class^="iti__"] { display: flex; }';
    
    
        }
       else{

		mobileErrorHandler.innerHTML = "Please change your Mobile Number"


		mobileNumberTextHandle.style = 'display:inline-block;'

		mobileNumberHandle.style = 'display:block;'

		submitButtonHandle.style = 'display:inline-block;'
		phoneButtonHandle.style = 'display:none'
						
		// emailButtonHandle.style = 'display:none'

		otpTextHandle.style = 'display:none'

		otp1Handle.style = 'display:none'

		otp2Handle.style = 'display:none'

		otp3Handle.style = 'display:none'

		otp4Handle.style = 'display:none'

		otp5Handle.style = 'display:none'

		otp6Handle.style = 'display:none'

		verifyButtonHandle.style = 'display:none'

		resendButtonHandle.style = 'display:none'

		changeButtonHandle.style = 'display:none'

		flag.innerHTML = '.iti__selected-flag[class^="iti__"] { display: flex; }';

		// txId = result.txId;
	   }
		//}
		//else {
		//alert('Invalid phone number.');
		//}
	});

if(window.location.pathname == '/'){
  console.log(defaultHomeHandle);
      defaultHomeHandle.addEventListener('click', function () {
      const elements = document.getElementsByClassName("sotp-widget");
      while (elements.length > 0) elements[0].remove();
      document.getElementById("MOLoginModal").style.display = 'block';

	});
}
    else{
	defaultloginHandle.addEventListener('click', function () {
		document.getElementById("MOLoginModal").style.display = 'none';
		document.getElementById("CustomerLogin").style.display = 'block';
		document.getElementById("login").style.display = 'block';

	});
    }
	document.getElementById("verifyButton").addEventListener('click', function () {
		otpvalue = $("#otpinput1,#otpinput2,#otpinput3,#otpinput4,#otpinput5,#otpinput6").map(function () { return this.value; }).get().join('');

		mobileErrorHandler.innerHTML = "Please Wait. Your OTP is being verified.";
		phoneButtonHandle.style = 'display:none';
	    // emailButtonHandle.style = 'display:none';
		if(contact== undefined)
		{
          contact = emailHandle.value;
		  document.getElementById('verifyotp').elements.namedItem("authtype").value = "email";
		}
		document.getElementById('verifyotp').elements.namedItem("txid").value = txId;
		document.getElementById('verifyotp').elements.namedItem("shop").value = window.location.hostname;
		document.getElementById('verifyotp').elements.namedItem("otp").value = otpvalue;
		document.getElementById('verifyotp').elements.namedItem("mobilenumber").value = contact;
		document.getElementById('verifyotp').elements.namedItem("shopcheckouturl").value = CheckoutUrl;
		document.getElementById('verifyotp').submit();
	

	});


	if (Hash_Param.has('txid')) {
		mobileErrorHandler.innerHTML = "You have entered invalid OTP"

		mobileNumberHandle.style = 'display:none'

		mobileNumberTextHandle.style = 'display:none'

		submitButtonHandle.style = 'display:none'

		otpTextHandle.style = 'display:block;'

		otp1Handle.style = 'display:inline-block;'

		otp2Handle.style = 'display:inline-block;'
		otp3Handle.style = 'display:inline-block;'

		otp4Handle.style = 'display:inline-block;'

		otp5Handle.style = 'display:inline-block;'

		otp6Handle.style = 'display:inline-block;'

var otpDigitsNumber = "6";
if( otpDigitsNumber == "4"){
  $('#otpinput5').hide();
  $('#otpinput6').hide();
}
		verifyButtonHandle.style = 'display:inline-block;'

       phoneButtonHandle.style = 'display:none';
    	whatsappButtonHandler.style = 'display:none';			
		if(Hash_Param.get('mobilenumber').includes('@'))
		{
		document.getElementById("resendButton").style = 'display:none;';
		changeButtonHandle.innerHTML = 'Change Email Address';
        changeButtonHandle.style = 'display:display:inline-block;';
		 document.getElementById("emailResendButton").style = 'display:inline-block';
		}
		else
		{
		document.getElementById("resendButton").style = 'display:inline-block;';
		changeButtonHandle.innerHTML = 'Change Phone Number';
        changeButtonHandle.style = 'display:display:inline-block;';
		}
		// document.getElementById("resendButton").style = 'display:inline-block; ';

		// changeButtonHandle.style = 'display:inline-block;';

		flag.innerHTML = '.iti__selected-flag[class^="iti__"] { display: none; }';

		document.head.appendChild(flag);

		// document.getElementById('my_button').click();
		txId = Hash_Param.get('txid');
		contact = Hash_Param.get('mobilenumber');
	}

});



function popup() {
    document.getElementById('MOLoginModal').style.display = 'block';
	document.getElementById('CustomerLogin').style.display = 'none';
	document.getElementById('login').style.display = 'none';
}



// When the user clicks anywhere outside of the modal, close it
// window.onclick = function (event) {
// 	if (event.target == document.getElementById('MOLoginModal')) {
// 		document.getElementById('MOLoginModal').style.display = 'none';
// 	}

// 	if (event.target == document.getElementById('updateModal')) {
// 		document.getElementById('updateModal').style.display = 'none';
// 	}

// }


function getCookie(cookieName) {
	let cookie = {};
	document.cookie.split(";").forEach(function (el) {
		let [key, value] = el.split("=");
		cookie[key.trim()] = value;
	})
	return cookie[cookieName];
}

function createCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toGMTString();
	}
	else {
		expires = "";
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}



}